export const X_AUTH_TOKEN = 'X_AUTH_TOKEN'
export const R_HEADER_X_REFERRAL_ID = 'referral-id'
export const HEADER_X_AUTH_TOKEN = 'X_AUTH_TOKEN'
